import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import FreeService from './components/FreeService';
import Insights from './components/Insights';
import Library from './components/Library';
import Consulting from './components/Consulting';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <FreeService />
      <Insights />
      <Library />
      <Consulting />
      <Contact />
      <Footer />
    </div>
  );
}
